(function () {
  function positiveNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : null;
  }

  function positiveInteger(value) {
    var number = Number(value);
    return Number.isInteger(number) && number > 0 ? number : null;
  }

  function calculateEstimate(input) {
    var widthIn = positiveNumber(input.widthIn);
    var heightIn = positiveNumber(input.heightIn);
    var quantity = positiveInteger(input.quantity);
    var minimumBillableArea = positiveNumber(input.minimumBillableArea);
    var variantPrice = positiveNumber(input.variantPrice);

    if (!widthIn || !heightIn || !quantity) return null;

    var actualArea = (widthIn * heightIn) / 144;
    if (!minimumBillableArea || !variantPrice) {
      return {
        canEstimate: false,
        widthIn: widthIn,
        heightIn: heightIn,
        quantity: quantity,
        actualArea: actualArea
      };
    }

    var billableArea = Math.max(actualArea, minimumBillableArea);
    var estimatedUnitPrice = Math.round(billableArea * variantPrice);

    return {
      canEstimate: true,
      widthIn: widthIn,
      heightIn: heightIn,
      quantity: quantity,
      actualArea: actualArea,
      billableArea: billableArea,
      minimumBillableArea: minimumBillableArea,
      estimatedUnitPrice: estimatedUnitPrice,
      estimatedTotal: estimatedUnitPrice * quantity,
      minimumApplies: actualArea < minimumBillableArea
    };
  }

  window.AtvioCustomEstimate = window.AtvioCustomEstimate || {};
  window.AtvioCustomEstimate.calculateEstimate = calculateEstimate;

  if (!window.document) return;

  function initAll() {
    document.querySelectorAll('[data-atvio-custom-estimate]:not([data-atvio-bound])').forEach(function (root) {
      root.dataset.atvioBound = 'true';
      init(root);
    });
  }

  function init(root) {
    var variants = [];
    var variantsEl = root.querySelector('[data-atvio-variants]');
    try {
      variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]');
    } catch (error) {
      variants = [];
    }

    var state = {
      variant: variants.find(function (variant) {
        return String(variant.id) === String(root.dataset.selectedVariantId);
      }) || variants[0] || null,
      latestEstimate: null
    };

    var widthInput = root.querySelector('[data-atvio-width]');
    var heightInput = root.querySelector('[data-atvio-height]');
    var quantityInput = root.querySelector('[data-atvio-quantity]');
    var result = root.querySelector('[data-atvio-result]');
    var error = root.querySelector('[data-atvio-error]');
    var total = root.querySelector('[data-atvio-total]');
    var billableArea = root.querySelector('[data-atvio-billable-area]');
    var minimumMessage = root.querySelector('[data-atvio-minimum-message]');
    var form = root.querySelector('form');
    var bodyField = root.querySelector('[data-atvio-quote-body]');
    var notesField = root.querySelector('[data-atvio-notes]');

    function formatArea(area) {
      return Number(area).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    function formatMoney(cents) {
      var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: root.dataset.currencyCode || 'USD'
        }).format(cents / 100);
      } catch (error) {
        return (cents / 100).toFixed(2);
      }
    }

    function setError(message) {
      error.textContent = message || '';
      error.hidden = !message;
    }

    function clearEstimate(message) {
      state.latestEstimate = null;
      result.hidden = true;
      setError(message || '');
    }

    function updateEstimate() {
      var estimate = calculateEstimate({
        widthIn: widthInput.value,
        heightIn: heightInput.value,
        quantity: quantityInput.value,
        minimumBillableArea: root.dataset.minimumBillableArea,
        variantPrice: state.variant && state.variant.price
      });

      if (!estimate) {
        clearEstimate('');
        return;
      }

      state.latestEstimate = estimate;
      setError('');

      if (!estimate.canEstimate) {
        result.hidden = true;
        return;
      }

      total.innerHTML = formatMoney(estimate.estimatedTotal);
      billableArea.textContent = formatArea(estimate.billableArea);

      if (estimate.minimumApplies) {
        minimumMessage.textContent = 'Minimum billable area of ' + formatArea(estimate.minimumBillableArea) + ' sq. ft. per unit applies.';
        minimumMessage.hidden = false;
      } else {
        minimumMessage.hidden = true;
      }

      result.hidden = false;
    }

    function buildBody() {
      var estimate = state.latestEstimate;
      var lines = [
        'Custom product size quote request',
        '',
        'Product: ' + root.dataset.productTitle,
        'Product ID: ' + root.dataset.productId,
        'Product URL: ' + root.dataset.productUrl,
        'Variant: ' + (state.variant ? state.variant.title : 'Unavailable'),
        'Variant ID: ' + (state.variant ? state.variant.id : 'Unavailable'),
        '',
        'Finished width: ' + widthInput.value + ' in.',
        'Finished height: ' + heightInput.value + ' in.',
        'Quantity: ' + quantityInput.value,
        '',
        'This is an unreviewed online estimate. Final pricing must be manually confirmed after reviewing dimensions, glass, hardware, and delivery requirements.'
      ];

      if (estimate && estimate.canEstimate) {
        lines.splice(lines.length - 1, 0,
          'Actual area per unit: ' + formatArea(estimate.actualArea) + ' sq. ft.',
          'Billable area per unit: ' + formatArea(estimate.billableArea) + ' sq. ft.',
          'Minimum billable area: ' + formatArea(estimate.minimumBillableArea) + ' sq. ft.',
          'Reference area unit price: ' + formatMoney(state.variant.price).replace(/<[^>]*>/g, '') + ' / sq. ft. ' + (root.dataset.currencyCode || ''),
          'Estimated unit price: ' + formatMoney(estimate.estimatedUnitPrice).replace(/<[^>]*>/g, ''),
          'Estimated product total: ' + formatMoney(estimate.estimatedTotal).replace(/<[^>]*>/g, '')
        );
      } else {
        lines.splice(lines.length - 1, 0, 'Estimate unavailable: missing valid reference price or minimum billable area.');
      }

      if (notesField && notesField.value.trim()) {
        lines.push('', 'Configuration / project notes:', notesField.value.trim());
      }

      return lines.join('\n');
    }

    [widthInput, heightInput, quantityInput].forEach(function (input) {
      input.addEventListener('input', updateEstimate);
      input.addEventListener('change', updateEstimate);
    });

    document.addEventListener('afterVariantChanged', function (event) {
      if (!event.detail || event.detail.sectionId !== root.dataset.sectionId || !event.detail.variant) return;
      state.variant = event.detail.variant;
      updateEstimate();
    });

    form.addEventListener('submit', function (event) {
      updateEstimate();
      if (!state.latestEstimate) {
        event.preventDefault();
        clearEstimate('Enter a valid finished width, finished height, and quantity before requesting a quote.');
        return;
      }
      bodyField.value = buildBody();
    });

    updateEstimate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  new MutationObserver(function () {
    window.requestAnimationFrame(initAll);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
